import { AccordionBody, AccordionHeader, AccordionItem, Col, ListGroup, ListGroupItem, Row } from "react-bootstrap";
import { useAuthState } from "../../context/AuthContext";
import { BsFillBuildingsFill } from "react-icons/bs";
import { useEffect, useState } from "react";
import CommonUtils from "../../utils/common";
import { FaExchangeAlt } from "react-icons/fa";
import defaultAvatar from "../../user.png";
import { FaXmark } from "react-icons/fa6";

const BuildingAccordionItem = ({ building, anlagen, tickets, hwChangeHandler, cancelTicketId, cancelModal }) => {

    const { user } = useAuthState();
    const UTILS = new CommonUtils();
    const changeTicket = tickets.find(t => t.ticket_type_id[0] === 11);
    const isInHwChange = tickets.some(t => t.ticket_type_id[0] === 11);
    const [buildingChangeNewHw, setBuildingChangeNewHw] = useState("");
    const [builingChangeDate, setBuildingChangeDate] = useState("");

    useEffect(() => {
        if (isInHwChange && changeTicket) {
            if (changeTicket.x_hv_wechsel_datum === "False") {
                setBuildingChangeDate("Nicht bekannt");
            } else {
                setBuildingChangeDate(
                    UTILS.dateToEuFormat(changeTicket.x_hv_wechsel_datum)
                );
            }

            if (changeTicket.x_hv_wechsel_house_management_id.length > 0) {
                setBuildingChangeNewHw(
                    changeTicket.x_hv_wechsel_house_management_id[1]
                );
            } else {
                setBuildingChangeNewHw(
                    changeTicket.x_hv_wechsel_house_management_name
                );
            }
        } else {
            // RESET kad se tiket obriše
            setBuildingChangeDate("");
            setBuildingChangeNewHw("");
        }
    }, [isInHwChange, changeTicket]);

    return (
        <AccordionItem id={`id-${building.id}`} eventKey={building.id} style={{ marginTop: 10, borderTop: "1px solid #ced4da" }}>
            <AccordionHeader>
                <div className="d-flex gap-3">
                    {user.id === building.id ?
                        <div className="avatar-image" style={{ backgroundImage: `url(${user?.image_1920 && user.image_1920 !== "False" ? 'data:image/*;base64,' + user.image_1920 : defaultAvatar})`, backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: 70, height: 70 }}></div> :
                        isInHwChange ?
                            <FaExchangeAlt size={70} className="text-warning" /> :
                            <BsFillBuildingsFill size={70} />
                    }
                    <div className="d-flex flex-column justify-content-center">
                        {isInHwChange && <b className="text-warning">Verwaltungswechsel</b>}
                        {building.name}
                        <small>{building.street}, {building.zip} {building.city}</small>
                        {building.x_objektbezeichnung !== "False" && building.x_objektbezeichnung !== "" &&
                            <small><span className="text-muted">Objektbezeichnung: </span>{building.x_objektbezeichnung}</small>
                        }
                    </div>
                </div>
            </AccordionHeader>
            <AccordionBody>
                <Row>
                    <Col xs="12" xl="4">
                        <small className="text-muted">Straße</small>
                        <p>{building.street}</p>
                    </Col>
                    <Col xs="12" xl="4">
                        <small className="text-muted">PLZ</small>
                        <p>{building.zip}</p>
                    </Col>
                    <Col xs="12" xl="4">
                        <small className="text-muted">Ort</small>
                        <p>{building.city}</p>
                    </Col>
                </Row>
                <Row>
                    <Col xs="12" xl="4">
                        <small className="text-muted">IBAN</small>
                        <p>{building.x_account_iban !== "False" ? building.x_account_iban : ""}</p>
                    </Col>
                    <Col xs="12" xl="4">
                        <small className="text-muted">Kontoinhaber</small>
                        <p>{building.x_account_owner}</p>
                    </Col>
                    <Col xs="12" xl="4">
                        <small className="text-muted">Verwaltung</small>
                        <p>{user.name}</p>
                    </Col>
                </Row>
                <Row hidden={isInHwChange === false}>
                    <Col xs="12" xl="4">
                        <small className="text-muted">Wechseldatum</small>
                        <p>{builingChangeDate}</p>
                    </Col>
                    <Col>
                        <small className="text-muted">Neue Hausverwaltung</small>
                        <p>{buildingChangeNewHw}</p>
                    </Col>
                </Row>
                <div className="d-flex justify-content-center">
                    <a hidden={isInHwChange} onClick={e => { e.preventDefault(); hwChangeHandler(building) }} href="/hausverwaltungwechsel/" className="link-energo">
                        <FaExchangeAlt /> Hausverwaltung-Wechsel
                    </a>
                    <a hidden={!isInHwChange} onClick={e => { e.preventDefault(); cancelTicketId(changeTicket.id); cancelModal(true) }} href="/hausverwaltungwechsel/abbrechen/" className="link-energo text-danger">
                        <FaXmark /> HV-Wechsel abbrechen</a>
                </div>
                <hr />
                <ListGroup variant="flush">
                    {anlagen.length > 0 ?
                        anlagen.map(a => (
                            <ListGroupItem key={`anlage-${a.id}`}>
                                <Row>
                                    <Col xs="12" md="4" xl="4">
                                        <small className="text-muted">Anlagennummer ENERGO</small>
                                        <p>{a.x_studio_field_mWMGR}</p>
                                    </Col>
                                    <Col xs="12" md="4" xl="4">
                                        <small className="text-muted">Energieform</small>
                                        <p>{a.x_studio_field_3eKe0}</p>
                                        {a.x_messtechnik_id !== "False" && a.x_messtechnik_variante === "Direktverrechnung" &&
                                            <small className="text-danger">(Direktverrechnung)</small>
                                        }
                                    </Col>
                                    <Col xs="12" md="4" xl="4">
                                        <small className="text-muted">Anlagenverwendung</small>
                                        <p>
                                            {
                                                a.x_anlagenverwendung !== "False" ?
                                                    a.x_anlagenverwendung === "Allgemeine Liegenschaftsteile" ?
                                                        a.x_anlagenverwendung_detail !== "False" ?
                                                            a.x_anlagenverwendung_detail
                                                            :
                                                            "Allgemeine Liegenschaftsteile"
                                                        :
                                                        a.x_studio_field_6T9W2 !== "False" ? `Top ${a.x_studio_field_6T9W2}` :
                                                            a.x_adresse_abw_top !== "False" ? `Top ${a.x_adresse_abw_top}` :
                                                                'Bestandseinheit'
                                                    :
                                                    "-"
                                            }
                                        </p>
                                    </Col>
                                </Row>
                            </ListGroupItem>
                        )) :
                        <p className="text-center">Sie haben keine Anlagen in diesem Gebäude</p>
                    }
                </ListGroup>
                <hr />
                <Row className="accordion-footer text-center">
                    <Col xs="4" className="border-right">
                        <a href={`/hw/dashboard/gebaeude/anlagen/${building.id}`} className="link-energo-light">
                            Anlagenverwaltung
                        </a>
                    </Col>
                    <Col xs="4" className="border-right">
                        <a href={`/hw/dashboard/energieliefervertraege/gebaeude/${building.id}`} className="link-energo-light">
                            Lieferverträge
                        </a>
                    </Col>
                    <Col xs="4">
                        <a href={`/hw/dashboard/gebaeude/dokumente/${building.id}`} className="link-energo-light">
                            Dokumente
                        </a>
                    </Col>
                </Row>
            </AccordionBody>
        </AccordionItem>
    )
}
export default BuildingAccordionItem;